import { Grid } from '@mui/material';
import { RoutalSelect, RoutalSelectMultiSelectOption, SMPalette } from '@nx-smartmonkey/ui';
import _ from 'lodash';
import { useEffect, useState } from 'react';

import {
  ApplicationsPreviewResponsiveLayout,
  DeviceTypes,
  deviceTypes,
} from '../../../../../components/applications-preview';
import { Project } from '../../../../../domain/project/Project';
import { ProjectSupervisorsStyle } from '../../../../../domain/project/projectSupervisors/style/ProjectSupervisorsStyle';
import Text from '../../../../../react-components/Text';

const PREVIEW_IFRAME_ID = `styling-preview-iframe`;

interface SupervisorsStylingPreviewProps {
  project: Project;
}

export const SupervisorsStylingPreview = ({ project }: SupervisorsStylingPreviewProps) => {
  const [supervisorsStyling, setSupervisorsStyling] = useState<ProjectSupervisorsStyle>(project.supervisors.style);
  const [device, setDevice] = useState<DeviceTypes>(`desktop`);

  useEffect(() => {
    if (!_.isEqual(supervisorsStyling.props, project.supervisors.style.props)) {
      const iframe = document.getElementById(PREVIEW_IFRAME_ID);
      if (iframe) {
        (iframe as any).src = (iframe as any).src;
      }
      setSupervisorsStyling(project.supervisors.style);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [project.supervisors.style.props]);

  return (
    <Grid container direction="column" style={{ height: `100%` }} wrap="nowrap">
      <Grid item container direction="row" justifyContent="end" style={{ padding: `12px` }}>
        <RoutalSelect
          id="select_device"
          containerStyle={{
            width: `220px`,
            marginRight: `8px`,
          }}
          popoverProps={{
            options: deviceTypes.map(
              (device): RoutalSelectMultiSelectOption => ({
                key: device,
                content: (
                  <Grid container direction="row" wrap="nowrap" style={{ width: `100%` }} alignItems="center">
                    <Text
                      variant="body"
                      style={{ cursor: `pointer` }}
                      intlId={`supervisors.app.preview.device.${device}`}
                    />
                  </Grid>
                ),
                onClick: () => setDevice(device),
              })
            ),
          }}
        >
          <Grid container direction="row" wrap="nowrap" style={{ width: `100%` }} alignItems="center">
            <Text
              variant="body"
              style={{ cursor: `pointer`, width: `100%`, textAlign: `start` }}
              intlId={`supervisors.app.preview.device.${device}`}
            />
          </Grid>
        </RoutalSelect>
      </Grid>

      <div style={{ width: `100%`, height: `1px`, backgroundColor: SMPalette.grey3 }} />

      <Grid item container style={{ height: `calc(100% - 75px)`, overflowY: `auto` }}>
        <ApplicationsPreviewResponsiveLayout device={device}>
          <iframe
            id={PREVIEW_IFRAME_ID}
            title={project.supervisors.style.page_title}
            src={`${project.getSupervisorsProjectSlugDomain()}/example`}
            width="100%"
            height="100%"
            style={{
              border: `none`,
              borderRadius: `2px`,
            }}
          />
        </ApplicationsPreviewResponsiveLayout>
      </Grid>
    </Grid>
  );
};
